import { ViewUserResource, useDeleteCustomerUsersByUserMutation } from '@/api/serverApi'
import { DeleteModal } from '@cfs-fixings/shared'
import toastHelper from '@cfs-fixings/shared/src/helpers/toastHelper'

const textSpec = {
  deleteModal: {
    successMessage: {
      title: 'Team member deleted successfully',
      message: 'Team member has been removed from the system',
    },
    errorMessage: {
      title: 'Team member to delete project',
      message: 'Team member cannot be deleted at this time, please try again later',
    },
    modal: {
      title: 'Delete',
      message: 'Are you sure you want to delete this team member?',
    },
    button: {
      text: 'Delete',
    },
  },
}

type PropTypes = {
  user?: ViewUserResource
  isOpen?: boolean
  onClose?: () => void
}

const DeleteTeamMemberModal = ({ user, isOpen = false, onClose }: PropTypes) => {
  const [deleteMutation, { isLoading }] = useDeleteCustomerUsersByUserMutation()

  const onDelete = () => {
    deleteMutation({ body: {}, user: user!.id }).unwrap().then(() => {
      toastHelper.success(
        textSpec.deleteModal.successMessage.title,
        textSpec.deleteModal.successMessage.message,
      )
      onClose?.()
    }).catch(() => {
      toastHelper.error(
        textSpec.deleteModal.errorMessage.title,
        textSpec.deleteModal.errorMessage.message,
      )
    },
    )
  }

  return (
    <DeleteModal
      isOpen={isOpen}
      onClose={() => onClose?.()}
      onConfirm={onDelete}
      title={`${textSpec.deleteModal.modal.title} ${user?.name}`}
      isLoading={isLoading}
      message={textSpec.deleteModal.modal.message}
    />
  )
}

export default DeleteTeamMemberModal
